/**
 * Partially this code was copied from the `connected-apps-ui`
 */

import enviro from 'enviro';
import Raven from 'raven-js';
import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
const baseTracker = createTracker({
  standalone: true,
  onError: err => {
    Raven.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
});
export const usageTracker = withSessionReplay(baseTracker, {
  // 10% sample rate QA only
  sampleRate: enviro.isQa() ? 0.1 : undefined,
  // Never show anything a user could possibly enter text into
  maskSelectors: ['input', 'textarea']
});
const NAMESPACE = 'Connections Embed Lib';
export const connectionsEmbedInteraction = eventProps => {
  usageTracker.track(NAMESPACE, 'Page Interaction', Object.assign({}, eventProps, {
    class: 'interaction'
  }));
};